import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { FinancialAccountValue } from "@components/history/details/financialAccounts/components/FinancialAccountValue";
import { HistoryFinancialAccountDetailsRow } from "../views/historyFinancialAccountDetailsViewConfig";

export const HistoryFinancialAccountOldValueCell: React.FC<
    CellContext<ViewTableFeatures, HistoryFinancialAccountDetailsRow, unknown>
> = ({ row }) => (
    <ViewTableCell>
        <FinancialAccountValue
            value={row.original.oldValue}
            field={row.original.field}
        />
    </ViewTableCell>
);

export const HistoryFinancialAccountNewValueCell: React.FC<
    CellContext<ViewTableFeatures, HistoryFinancialAccountDetailsRow, unknown>
> = ({ row }) => (
    <ViewTableCell>
        <FinancialAccountValue
            value={row.original.newValue}
            field={row.original.field}
        />
    </ViewTableCell>
);
